module.exports = __webpack_public_path__ + "6ee4c857c892f299eaf2e6a8d3fa441f.jpg";